// TypingAnimation.js
import React, { useEffect, useRef } from "react";
import Typed from "typed.js";

const TypingAnimation = () => {
  const typedElement = useRef(null);

  useEffect(() => {
    const options = {
      strings: [
        "Full Stack Web Developer",
        "Flutter Developer",
        "iOS Developer",
        "Blockchain Developer",
        "Freelancer",
      ],
      typeSpeed: 50,
      backSpeed: 50,
      loop: true,
    };

    const typed = new Typed(typedElement.current, options);

    return () => {
      typed.destroy();
    };
  }, []);

  return <span className="animate" ref={typedElement}></span>;
};

export default TypingAnimation;
